import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  Col,
  Container,
  Form,
  Row,
  OverlayTrigger,
  Popover,
} from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { Badge, Button, Dropdown } from "react-bootstrap";
import { DateRangePicker } from "react-date-range";
import moment from "moment";
import moments from "moment-timezone";
import { toast } from "react-toastify";
import WhatsAppAPI from "../../api/WhatsAppAPI";
import Confirm from "../Confirm";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const Templateview = ({ selectedWhatsAppSetting }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [templateData, setTemplateData] = useState(
    location.state ? location.state : {},
  );

  // Unix timestamp ko readable date format me convert karne ke liye:

  const [body, setBody] = useState([]);
  const [isSpinner, setIsSpinner] = useState(true);
  const [templateDelete, setTemplateDelete] = useState(false);
  const [rowData, setRowData] = useState();
  const [formattedData, setFormattedData] = useState();
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileURL, setSelectedFileURL] = useState(null);
  const [selectedFileType, setSelectedFileType] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const docxIcon = "/user_images/doc-icon.png";
  const fileInputRef = useRef(null);

  const [dateRange, setDateRange] = useState([]);
  const [showCalendar, setShowCalendar] = useState(false);
  const calendarRef = useRef(null);
  // console.log("templateData->", templateData);
  useEffect(() => {
    //setParameters({});

    if (templateData && typeof tamplateparms === "object") {
      const {
        sendToAdmin,
        file,
        file_id,
        whatsapp_number_admin,
        ...restParameters
      } = templateData;
      if (file) {
        setSelectedFile(file);
        setSelectedFileType(file.type);
        setSelectedFileURL(URL.createObjectURL(file));
      }
    }
  }, [templateData]);
  const renderFormattedMessage = () => {
    let formattedText = templateData?.message_body || "";
    //Object.keys(parameters).forEach((key) => {
    //  const placeholder = `{{${key}}}`;
    //  const replacement = parameters[key] || placeholder;
    //  formattedText = formattedText.replace(new RegExp(placeholder, "g"), replacement);
    //});
    formattedText = formattedText.replace(/(\n)+/g, "<br />");
    formattedText = formattedText.replace(/\*(.*?)\*/g, "<strong>$1</strong>");
    return <span dangerouslySetInnerHTML={{ __html: formattedText }} />;
  };
  const getHeader = () => {
    if (selectedFileURL) {
      if (selectedFileType && selectedFileType.includes("image")) {
        return (
          <img
            src={selectedFileURL}
            alt="Uploaded Preview"
            className="img-fluid rounded w-100 mb-2"
            style={{ height: "200px", objectFit: "cover" }}
          />
        );
      } else if (selectedFileType && selectedFileType.includes("video")) {
        return (
          <video
            src={selectedFileURL}
            controls
            className="img-fluid rounded w-100 mb-2"
            style={{ height: "200px", objectFit: "cover" }}
          />
        );
      } else if (selectedFileType) {
        return (
          <a href={selectedFileURL} target="_blank" rel="noopener noreferrer">
            <img
              src={docxIcon}
              alt="Document Thumbnail"
              className="img-fluid rounded w-100 mb-2"
              style={{ height: "200px", objectFit: "cover" }}
            />
          </a>
        );
      }
    }

    if (templateData?.header) {
      //console.log("hear pankaj");

      switch (templateData.header) {
        case "IMAGE":
          return (
            <img
              src={templateData.header_image_url}
              alt="Template Header"
              className="img-fluid rounded w-100 mb-2"
              style={{ height: "200px", objectFit: "cover" }}
            />
          );
        case "VIDEO":
          return (
            <video
              src={templateData.header_video_url}
              controls
              className="img-fluid rounded w-100 mb-2"
              style={{ height: "200px", objectFit: "cover" }}
            />
          );
        case "DOCUMENT":
          return (
            <a
              href={templateData.header_document_url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={docxIcon}
                alt="Document Thumbnail"
                className="img-fluid rounded w-100 mb-2"
                style={{ height: "200px", objectFit: "cover" }}
              />
            </a>
          );
        default:
          return <strong>{templateData.header_text}</strong>;
      }
    }

    return null;
  };

  const getFooter = () =>
    templateData.footer ? (
      <div className="template-footer text-muted">{templateData.footer}</div>
    ) : null;

  const getButtons = () => {
    if (templateData.buttons && templateData.buttons.length > 0) {
      const quickReplyButtons = templateData.buttons.filter(
        (button) => button.type === "QUICK_REPLY",
      );
      const otherButtons = templateData.buttons.filter(
        (button) => button.type !== "QUICK_REPLY",
      );

      return (
        <div className="template-buttons mt-3">
          {otherButtons.map((button, index) => (
            <div key={index} className="btn btn-outline-secondary btn-sm mb-2">
              {button.text}
            </div>
          ))}
          {quickReplyButtons &&
            quickReplyButtons.map((button, index) => (
              <div
                key={index}
                className="btn btn-outline-secondary btn-sm mb-2"
              >
                {button.text}
              </div>
            ))}
        </div>
      );
    }
    return null;
  };
  const handleBack = () => {
    navigate("/whatsapp_template");
  };
  const closeCalendar = () => {
    setShowCalendar(false);
  };
  const removeSelectedRow = (data) => {
    setTemplateDelete(true);

    setRowData(data?.templateData);
  };
  const deleteTemplate = async () => {
    if (rowData.id && rowData.name) {
      const result = await WhatsAppAPI.deleteTemplateRecord(
        rowData.id,
        rowData.name,
        selectedWhatsAppSetting,
      );
      if (result.success) {
        setTemplateDelete(false);
        //toast.success('Template deleted successfully.');
        navigate("/whatsapp_template");
        //setTimeout(() => {
        //}, 2000);
        //fetchAllTemplates(selectedWhatsAppSetting);
      } else {
        setTemplateDelete(false);
        //toast.error(result.error.message);
      }
    }
  };

  const handleSelect = (ranges) => {
    setDateRange([ranges.selection]);
  };

  const selectDate = () => {
    setShowCalendar(false);
    let firstdate = moments(dateRange[0].startDate)
      .tz("Asia/Kolkata")
      .startOf("day")
      .unix();
    let lastdate = moments(dateRange[0].endDate)
      .tz("Asia/Kolkata")
      .endOf("day")
      .unix();
    init(firstdate, lastdate);
  };
  //  useEffect(() => {
  //    setDateRange([
  //      {
  //        startDate: moment().startOf('month').format(),
  //        endDate: moment().endOf('month').format(),
  //        key: 'selection'
  //      }
  //    ]);
  //
  //    let firstdate = moment().tz("Asia/Kolkata").startOf('month').unix();
  //    let lastdate = moment().tz("Asia/Kolkata").endOf('month').unix();
  //
  //
  //
  //    init(firstdate, lastdate);
  //    setIsSpinner(false);
  //
  //  }, [selectedWhatsAppSetting]);
  useEffect(() => {
    const currentTime = moment().tz("Asia/Kolkata").unix(); // Current timestamp
    const ninetyDaysAgo = currentTime - 90 * 24 * 60 * 60; // 90 days ago

    let firstdate = Math.max(
      moment().tz("Asia/Kolkata").startOf("month").unix(),
      ninetyDaysAgo,
    );
    let lastdate = Math.min(
      moment().tz("Asia/Kolkata").endOf("month").unix(),
      currentTime,
    );

    setDateRange([
      {
        startDate: moment.unix(firstdate).format(),
        endDate: moment.unix(lastdate).format(),
        key: "selection",
      },
    ]);

    init(firstdate, lastdate);
  }, [selectedWhatsAppSetting]);

  async function init(start = "", end = "") {
    // if (!selectedWhatsAppSetting) return; // Prevent API call if the value is empty
    // console.log("selectedWhatsAppSetting ->",selectedWhatsAppSetting);

    const billData = await WhatsAppAPI.getTemplateaAmountBySetting(
      templateData?.id,
      selectedWhatsAppSetting,
      start,
      end,
    );
    //const billData = { success: false };

    if (billData.success) {
      let totalAmountSpent = 0;
      let totalCostPerDelivered = 0;
      let totalSent = 0;
      let totalDelivered = 0;
      let totalRead = 0;
      const formattedData = billData.result.map((item) => ({
        date: new Date(item.start * 1000).toLocaleDateString(),
        sent: item.sent || 0,
        delivered: item.delivered || 0,
        read: item.read || 0,
      }));
      setFormattedData(formattedData);
      // console.log("billData",billData);
      billData.result.forEach((record) => {
        totalSent += record.sent || 0;
        totalDelivered += record.delivered || 0;
        totalRead += record.read || 0;
        record?.cost?.forEach((cost) => {
          if (cost.type === "amount_spent" && cost.value) {
            totalAmountSpent += cost.value;
          }
          //if (cost.type === 'cost_per_delivered' && cost.value) {
          //    totalCostPerDelivered += cost.value;//only one time
          //}
        });
        const costPerDelivered = record?.cost?.find(
          (cost) => cost.type === "cost_per_delivered" && cost.value,
        );
        if (costPerDelivered) {
          totalCostPerDelivered = costPerDelivered.value;
        }
      });
      setBody({
        totalSent,
        totalDelivered,
        totalRead,
        totalAmountSpent: totalAmountSpent.toFixed(2),
        totalCostPerDelivered: totalCostPerDelivered.toFixed(2),
      });
      // console.log("Total Sent Messages:", totalSent);
      // console.log("Total Delivered Messages:", totalDelivered);
      // console.log("Total Read Messages:", totalRead);
      // console.log("Total Amount Spent:", totalAmountSpent.toFixed(2));
      // console.log("Total Cost Per Delivered:", totalCostPerDelivered.toFixed(2));
      //let body = fetchTableData(billData.result);
      //setBillBody(body);
    } else {
      setBody([]);
      //setBillBody(null);
      //toast.error(billData.error);
    }
    //setIsSpinner(true);
  }

  const editTemplate = (data) => {
    navigate(`/whatsapp_template/add`, { state: data?.templateData });
  };

  // --- Carousel Template Detection ---
  const isCarouselTemplate =
    templateData?.template_type === "carousel" ||
    (templateData?.components &&
      templateData.components.some((c) => c.type === "carousel"));

  // --- Carousel Card Renderer ---
  const renderCarouselCards = () => {
    // Get cards from either DB or API structure
    let cards = [];
    //console.log("templateData.cards",templateData.cards)
    if (templateData.cards && Array.isArray(templateData.cards)) {
      //console.log("Raw DB cards:", templateData.cards);
      cards = templateData.cards.map((card) => {
        // Robust header_image_url mapping
        let header_image_url =
          card.header_image_url ||
          card.header?.image_url ||
          (card.header?.handle && /^https?:\/\//.test(card.header.handle)
            ? card.header.handle
            : "") ||
          (card.header_type === "IMAGE" &&
          card.header_handle &&
          /^https?:\/\//.test(card.header_handle)
            ? card.header_handle
            : "");

        let header_video_url =
          card.header_video_url ||
          card.header?.video_url ||
          (card.header_type === "VIDEO" &&
          card.header_handle &&
          /^https?:\/\//.test(card.header_handle)
            ? card.header_handle
            : "");

        const mapped = {
          header_type: card.header_type || card.header?.format || "IMAGE",
          header_handle: card.header_handle || card.header?.handle || "",
          header_image_url,
          header_video_url,
          body_text: card.body_text || card.body?.text || "",
          buttons: card.buttons || [],
          body_text_example: card.body_text_example || card.body?.example || [],
        };
        //console.log("Mapped DB card:", mapped);
        return mapped;
      });
    } else if (templateData.components) {
      const carouselComp = templateData.components.find(
        (c) => c.type === "carousel",
      );
      if (carouselComp && Array.isArray(carouselComp.cards)) {
        //console.log("Raw API cards:", carouselComp.cards);
        cards = carouselComp.cards.map((card) => {
          const header = card.components.find((c) => c.type === "header");
          const body = card.components.find((c) => c.type === "body");
          const buttons = card.components.find((c) => c.type === "buttons");
          let header_image_url = header?.image_url || "";
          if (
            !header_image_url &&
            header?.example?.header_handle?.[0] &&
            /^https?:\/\//.test(header.example.header_handle[0])
          ) {
            header_image_url = header.example.header_handle[0];
          }
          const mapped = {
            header_type: header?.format || "image",
            header_handle: header?.example?.header_handle?.[0] || "",
            header_image_url,
            body_text: body?.text || "",
            buttons: buttons?.buttons || [],
            body_text_example: body?.example?.body_text?.[0] || [],
          };
          //console.log("Mapped API card:", mapped);
          return mapped;
        });
      }
    }
    if (!cards.length) return null;
    return (
      <div
        style={{ overflowX: "auto", whiteSpace: "nowrap", paddingBottom: 16 }}
      >
        {cards.map((card, idx) => (
          <div
            key={idx}
            style={{
              display: "inline-block",
              width: 320, // increased from 300
              marginRight: 16,
              verticalAlign: "top",
            }}
          >
            <Card className="shadow-sm" style={{ minHeight: 250 }}>
              <Card.Body>
                {/* Header image */}
                {card.header_type === "IMAGE" && card.header_image_url && (
                  <img
                    src={card.header_image_url}
                    alt="Card"
                    className="img-fluid rounded w-100 mb-2"
                    style={{ height: "160px", objectFit: "cover" }}
                  />
                )}

                {card.header_type === "VIDEO" && card.header_video_url && (
                  <video
                    src={card.header_video_url}
                    controls
                    className="rounded w-100 mb-2"
                    style={{ height: "160px", objectFit: "cover" }}
                  />
                )}
                {/* Card body text */}
                <div
                  className="mb-2"
                  style={{
                    minHeight: 48,
                    fontWeight: 500,
                    fontSize: "1rem",
                    color: "#222",
                    padding: "8px 0",
                    background: "#f8f9fa",
                    borderRadius: "4px",
                    wordBreak: "break-word",
                    marginTop: "8px",
                    whiteSpace: "normal", // ensure text wraps
                  }}
                >
                  {card.body_text}
                </div>
                {/* Body text variable examples */}
                {card.body_text_example &&
                  card.body_text_example.length > 0 && (
                    <div className="mb-2">
                      <strong>Examples:</strong>
                      <ul>
                        {card.body_text_example.map((ex, i) => (
                          <li key={i}>{ex}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                {/* Buttons */}
                <div>
                  {card.buttons &&
                    card.buttons.map((btn, bidx) => (
                      <div key={bidx} className="mb-1">
                        {btn.type === "QUICK_REPLY" && (
                          <Button
                            size="sm"
                            variant="outline-primary"
                            style={{ width: "100%" }}
                          >
                            {btn.text}
                          </Button>
                        )}
                        {btn.type === "URL" && (
                          <div>
                            <Button
                              size="sm"
                              variant="outline-success"
                              style={{ width: "100%" }}
                              href={btn.url || "#"}
                              target="_blank"
                            >
                              {btn.text}
                            </Button>
                            {btn.example && (
                              <div
                                style={{ fontSize: "0.85em", color: "#888" }}
                              >
                                Example: {btn.example}
                              </div>
                            )}
                          </div>
                        )}
                        {btn.type === "PHONE_NUMBER" && (
                          <Button
                            size="sm"
                            variant="outline-info"
                            style={{ width: "100%" }}
                          >
                            {btn.text}
                          </Button>
                        )}
                      </div>
                    ))}
                </div>
              </Card.Body>
            </Card>
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      <div className="app-view-page">
        <div className="lead-header">
          <div className="min-w-0 flex-grow-1 pe-2">
            <p className="lead-label">Template</p>
            <h3 className="lead-title text-break">
              {(templateData?.templatename || templateData?.name || "—")
                .toString()
                .replace(/_/g, " ")}
            </h3>
            {templateData?.category && (
              <div className="text-muted small text-uppercase mt-1">
                {templateData.category}
              </div>
            )}
          </div>
          <div className="lead-actions">
            <div
              className="position-relative"
              style={{ minWidth: "min(280px, 100%)" }}
            >
              <Form.Group className="d-flex align-items-center mb-0">
                <Form.Control
                  type="text"
                  readOnly
                  className="border p-2 cursor-pointer form-control"
                  value={`${moment(dateRange[0]?.startDate).format(
                    "DD/MM/YYYY",
                  )} - ${moment(dateRange[0]?.endDate).format("DD/MM/YYYY")}`}
                  onClick={() => setShowCalendar(!showCalendar)}
                  style={{ width: "100%" }}
                />
              </Form.Group>

              {showCalendar && (
                <div ref={calendarRef} className="calendar-wrapper">
                  <Card bg="light" className="shadow">
                    <Card.Body>
                      <DateRangePicker
                        showSelectionPreview={true}
                        ranges={dateRange}
                        onChange={handleSelect}
                        direction="horizontal"
                        months={2}
                        moveRangeOnFirstSelection={false}
                        maxDate={new Date()}
                        minDate={
                          new Date(
                            new Date().setDate(new Date().getDate() - 88),
                          )
                        }
                      />
                    </Card.Body>
                    <Card.Footer className="text-end">
                      <Button className="me-2" onClick={closeCalendar}>
                        Close
                      </Button>
                      <Button onClick={selectDate}>Select Date</Button>
                    </Card.Footer>
                  </Card>
                </div>
              )}
            </div>

            <Button className="btn-sm btn-back" onClick={handleBack}>
              Back
            </Button>
            <Button
              className="btn-sm btn-delete"
              onClick={() => removeSelectedRow({ templateData })}
            >
              Delete
            </Button>
          </div>
        </div>

      {isSpinner ? (
        <Container fluid className="px-0 mt-3">
          <Row className="g-0 pb-3">
            <div className="col-md-4">
              <Card className="shadow">
                <Card.Body>
                  {/* <Card.Title className="fw-bold mb-3">
                    {" "}
                    <h5 className="mt-1 text-capitalize">
                      {templateData?.templatename}{" "}
                      <span>• {templateData?.language}</span>
                    </h5>
                  </Card.Title> */}
                  <div className="whatsapp-background w-100">
                    <div className="template-box">
                      {/* Carousel or normal template rendering */}
                      {isCarouselTemplate ? (
                        <>
                          {/* Main message body */}
                          <div className="template-content mt-3 mb-3">
                            {templateData?.message_body}
                          </div>
                          {/* Carousel cards */}
                          {renderCarouselCards()}
                        </>
                      ) : (
                        <>
                          {getHeader()}
                          <div className="template-content mt-3">
                            {renderFormattedMessage()}
                            {getFooter()}
                            {getButtons()}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
            <div className="col-md-8">
              <div className="row g-4">
                <div className="col-md-6">
                  <Card className="text-center shadow-sm">
                    <Card.Body>
                      <Card.Title className="fw-bold">
                        Amount spent
                        <OverlayTrigger
                          placement="auto"
                          overlay={
                            <Popover id={`popover-positioned-auto`}>
                              <Popover.Body>
                                The total amount spent on message templates,
                                with costs attributed to the first template sent
                                in a 24-hour conversation window. Data is
                                available 1 hour after enabling performance
                                insights.
                              </Popover.Body>
                            </Popover>
                          }
                        >
                          <i
                            className="fa-solid fa-circle-info text-secondary ms-1"
                            style={{ cursor: "pointer" }}
                          ></i>
                        </OverlayTrigger>
                      </Card.Title>

                      <p className="display-6 fw-semibold mt-2">
                        {body.totalAmountSpent}
                      </p>
                    </Card.Body>
                  </Card>
                </div>

                <div className="col-md-6">
                  <Card className="text-center shadow-sm">
                    <Card.Body>
                      <Card.Title className="fw-bold">
                        Cost per message delivered{" "}
                        <OverlayTrigger
                          placement="auto"
                          overlay={
                            <Popover id={`popover-positioned-auto`}>
                              <Popover.Body>
                                Cost per message is calculated by dividing the
                                amount spent by the messages delivered within 7
                                days. Data is available 1 hour after enabling
                                performance insights.{" "}
                              </Popover.Body>
                            </Popover>
                          }
                        >
                          <i
                            className="fa-solid fa-circle-info text-secondary ms-1"
                            style={{ cursor: "pointer" }}
                          ></i>
                        </OverlayTrigger>
                      </Card.Title>
                      <p className="display-6 fw-semibold mt-2">
                        {body.totalCostPerDelivered}
                      </p>
                    </Card.Body>
                  </Card>
                </div>
              </div>

              <Card className="mt-4 shadow-sm">
                <Card.Body>
                  <Card.Title className="fw-bold mb-3">Performance</Card.Title>
                  <div className="row text-center">
                    <div className="col-md-4">
                      <h6 className="text-muted">Messages sent</h6>
                      <p className="h4 fw-semibold">{body?.totalSent}</p>
                    </div>
                    <div className="col-md-4">
                      <h6 className="text-muted">Messages delivered</h6>
                      <p className="h4 fw-semibold">{body?.totalDelivered}</p>
                    </div>
                    <div className="col-md-4">
                      <h6 className="text-muted">Messages read</h6>
                      <p className="h4 fw-semibold">{body?.totalRead}</p>
                    </div>
                    {/*<div className="col-md-3">
                    <h6 className="text-muted">Replies</h6>
                    <p className="h4 fw-semibold">0</p>
                  </div>*/}
                  </div>

                  <div
                    className="mt-4 bg-light d-flex align-items-center justify-content-center rounded"
                    style={{ height: "200px" }}
                  >
                    {/*<p className="text-muted">Graph Placeholder</p>*/}
                    <ResponsiveContainer width="100%">
                      <LineChart data={formattedData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="date" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Line
                          type="monotone"
                          dataKey="sent"
                          stroke="#ff4d4f"
                          name="Messages Sent"
                        />
                        <Line
                          type="monotone"
                          dataKey="delivered"
                          stroke="#722ed1"
                          name="Messages Delivered"
                        />
                        <Line
                          type="monotone"
                          dataKey="read"
                          stroke="#52c41a"
                          name="Messages Read"
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Row>
        </Container>
      ) : (
        <div className="sk-cube-grid mt-4">
          <div className="sk-cube sk-cube1"></div>
          <div className="sk-cube sk-cube2"></div>
          <div className="sk-cube sk-cube3"></div>
          <div className="sk-cube sk-cube4"></div>
          <div className="sk-cube sk-cube5"></div>
          <div className="sk-cube sk-cube6"></div>
          <div className="sk-cube sk-cube7"></div>
          <div className="sk-cube sk-cube8"></div>
          <div className="sk-cube sk-cube9"></div>
        </div>
      )}
      </div>
      {templateDelete && (
        <Confirm
          show={templateDelete}
          onHide={() => setTemplateDelete(false)}
          deleteTemplate={deleteTemplate}
          title="Confirm Delete"
          message="You are going to delete the record. Are you sure?"
          table="template"
        />
      )}
    </>
  );
};

export default Templateview;
